module.exports = __webpack_public_path__ + "img/3.067dd140.png";